import { AddressesService } from './../../shared/services/addresses.service';
import { DictionaryValuesService } from './../../shared/services/dictionaryValues.service';
import { OrderStatusChange } from './../../shared/models/classes/order/orderStatusChange';
import { OrderStatus } from './../../shared/models/enums/order-status.enum';
import { OrdersService } from '@services/orders.service';
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ChangeDetectorRef,
  ElementRef,
} from '@angular/core';
import { Order } from '@classes/order/order';
import { UiService } from '@services/ui.service';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { UsersService } from '@services/users.service';
import { RoleName } from '@enums/role-name.enum';
import { User } from '@classes/user/user';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { AuthService } from '@services/auth.service';
import { MatTableDataSource } from '@angular/material/table';
import { OrderPatient } from '@classes/order/orderPatient';
import { MatPaginator } from '@angular/material/paginator';
import { OrderType } from '@enums/order-type.enum';
import { MatAccordion } from '@angular/material/expansion';
import { OrderStepsService } from '@services/orderSteps.service';
import { MatSort } from '@angular/material/sort';
import { SitesService } from '@services/sites.service';
import { Site } from '@classes/site';
import { DictionaryValue } from '@classes/dictionary/dictionaryValue';
import * as moment from 'moment';
import { Address } from '@classes/address';
import jsPDF, { jsPDFOptions } from 'jspdf';
import { RemindersService } from '@services/reminders.service';
import { Reminder } from '@classes/reminder';
import dayjs from 'dayjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '@components/confirm-dialog/confirm-dialog.component';
import { InternalComment } from '@classes/order/internalComment';
import { OrderStepTemperature } from '@classes/order/orderStepTemperature';
import { OrderScan } from '@classes/order/orderScan';
import { FileService } from '@services/file.service';
import { FileInfo } from '@classes/file/fileInfo';
import { AddOrderDocumentRequest } from '@classes/order/add-order-document-request';
import { OrderDocumentsDialogComponent } from './order-documents-dialog/order-documents-dialog.component';
import { MWorkerService } from '@services/m-worker.service';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss'],
})
export class OrderDetailComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  @ViewChild('TablePatientsPaginator', { static: false })
  patientsPaginator: MatPaginator;
  @ViewChild('TableHistoryPaginator', { static: false })
  historyPaginator: MatPaginator;

  @ViewChild('TableHistorySort', { static: false }) tableHistorySort: MatSort;
  @ViewChild('TablePatientsSort', { static: false }) tablePatientsSort: MatSort;

  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChild('toPdf', { static: false }) pdfTable: ElementRef;

  order: Order;
  isReadOnly = true;
  doesShowRoute = false;
  onEditMode = false;
  stepOnEditMode = false;

  orderStatus = OrderStatus;

  isRestricted: boolean;
  isSuperAdmin: boolean;
  isClient: boolean;
  canSeeInternalComment: boolean;
  drivers: User[];
  isLoading = true;
  isLoadingDrivers = false;
  isLoadingSites = false;
  isLoadingEmail = false;
  isLoadingUrgencies = false;
  isLoadingLots = false;
  isLoadingAddresses = false;
  isLoadingDocuments = false;
  showDrivers = false;
  showNewVoucher = false;
  showEmail = false;
  isDispatcher: boolean;
  hasScans = false;
  canEdit: boolean;
  canEditVoucher: boolean;
  invalidMessage = '';
  canExportDocuments: boolean = false;
  canSeePrice: boolean = false;

  isLoadingRoadLetter = false;

  editSite: boolean;
  sites: Site[];

  editInfos: boolean;
  urgencies: DictionaryValue[];
  lots: DictionaryValue[];

  senders: Address[];
  receivers: Address[];

  reminder: Reminder;
  recallTimer: number;

  editInternalCommentFlag: boolean = false;
  internalComment: string = '';

  temperatures: OrderStepTemperature[] = [];

  driverForm = new UntypedFormGroup({
    driver: new UntypedFormControl('', Validators.required),
    comment: new UntypedFormControl(''),
  });

  formVoucher = new UntypedFormGroup({
    newTransportVoucher: new UntypedFormControl('', Validators.required),
  });

  formMail = new UntypedFormGroup({
    email: new UntypedFormControl(null, [
      Validators.required,
      Validators.email,
    ]),
  });

  formInfos: UntypedFormGroup;
  formStep: UntypedFormGroup;

  formInternalComment: UntypedFormGroup;

  formArrivedOn = new UntypedFormGroup({
    newArrivedOn: new UntypedFormControl(null, Validators.required),
  });

  formCompletedOn = new UntypedFormGroup({
    newCompletedOn: new UntypedFormControl(null, Validators.required),
  });

  displayedColumns: string[] = [
    'firstname',
    'birthname',
    'lastname',
    'birthdate',
    'productType',
    'quantity',
  ];
  displayedColumnsHistory: string[] = [
    'status',
    'comment',
    'createdBy',
    'createdOn',
  ];
  dataSource: MatTableDataSource<OrderPatient>;
  history: MatTableDataSource<OrderStatusChange>;
  disabledExportMessage = '';
  canExport = false;

  allScans: OrderScan[] = [];

  constructor(
    private route: ActivatedRoute,
    private ordersSrv: OrdersService,
    private uiSrv: UiService,
    private router: Router,
    private usersSrv: UsersService,
    private authSrv: AuthService,
    private cdr: ChangeDetectorRef,
    private orderStepsSrv: OrderStepsService,
    private sitesSrv: SitesService,
    private dictionarySrv: DictionaryValuesService,
    protected fb: UntypedFormBuilder,
    private adressesSrv: AddressesService,
    private remindersSrv: RemindersService,
    private dialog: MatDialog,
    private _fileSrv: FileService,
    private _mWorkerService: MWorkerService,
  ) {}

  ngOnInit() {
    this.isLoading = true;
    this.isDispatcher =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin ||
      this.authSrv.getUser().role.name === RoleName.dispatcher;

    this.canExportDocuments =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin ||
      this.authSrv.getUser().role.name === RoleName.admin_client ||
      this.authSrv.getUser().role.name === RoleName.driver;

    this.canSeePrice =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin;

    this.isRestricted =
      this.authSrv.getUser().role.name === RoleName.client ||
      this.authSrv.getUser().role.name === RoleName.driver;
    this.isClient =
      this.authSrv.getUser().role.name === RoleName.client ||
      this.authSrv.getUser().role.name === RoleName.admin_client;
    if (this.isClient) {
      this.displayedColumnsHistory = ['status', 'createdBy', 'createdOn'];
    }
    this.isSuperAdmin =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin ||
      this.authSrv.getUser().role.name === RoleName.dispatcher;
    this.canSeeInternalComment =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin;

    this.getRouteData();

    this.groupBy();

    this.initSubscriptions();
    this.initTable();

    this.checkIfCanEdit();

    this.concatAllScans();
  }

  private getRouteData(): void {
    this.route.data.subscribe((data: { order: Order }) => {
      this.order = data.order;
      this.canExport = this.checkIfCanExport();
      this.isLoading = false;
    });
  }

  groupBy() {
    let groupPickedUp = {};
    if (this.order.sender.scans.length > 0) {
      this.hasScans = true;
      this.order.sender.scans.forEach(function (a) {
        if (a.code) {
          groupPickedUp[a.container.description] =
            groupPickedUp[a.container.description] || [];
          groupPickedUp[a.container.description].push(a);
        }
      });
    }

    let groupDelivered = {};

    this.order.receivers.map((receiver) => {
      if (receiver.scans.length > 0) {
        this.hasScans = true;
        if (receiver.isPickup) {
          receiver.scans.forEach(function (a) {
            if (a.code) {
              groupPickedUp[a.container.description] =
                groupPickedUp[a.container.description] || [];
              groupPickedUp[a.container.description].push(a);
            }
          });
        } else {
          receiver.scans.forEach(function (a) {
            if (a.code) {
              groupDelivered[a.container.description] =
                groupDelivered[a.container.description] || [];
              groupDelivered[a.container.description].push(a);
            }
          });
        }
      }
    });

    this.order.scansPickedGroupedByContainer = groupPickedUp;
    this.order.scansDeliveredGroupedByContainer = groupDelivered;
  }

  showStatusText(status: OrderStatus): string {
    return 'orders.status.' + OrderStatus[status];
  }

  showTypeText(type: OrderType): string {
    return 'orders.type.' + OrderType[type];
  }

  private initSubscriptions(): void {
    this.subscription.add(
      this.uiSrv.loadingStateChanged.subscribe((loadingState) => {
        this.isLoading = loadingState;
      }),
    );

    this.subscription.add(
      this.ordersSrv.selectedOrderChanged.subscribe((selectedOrder) => {
        this.order = selectedOrder;
        this.cdr.detectChanges();
        this.onEditFinished();
      }),
    );

    if (this.canSeeInternalComment) {
      this.subscription.add(
        this.ordersSrv
          .getInternalComment(this.order.id)
          .subscribe((internalCommentFromSrv: InternalComment) => {
            this.internalComment = internalCommentFromSrv.internalComment;
          }),
      );
    }

    this.remindersSrv
      .getByOrderId(this.order.id)
      .subscribe((reminderFromSrv) => {
        if (reminderFromSrv.length > 0) {
          this.reminder = reminderFromSrv[0];
          this.initRecallTimer();
        } else {
          this.reminder = null;
        }
      });
  }

  private initRecallTimer() {
    const startDate = dayjs(this.order.startDate);
    const recallDate = dayjs(this.reminder.dateTime);
    this.recallTimer = startDate.diff(recallDate, 'minute');
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.order.patients);

    this.history = new MatTableDataSource(this.order.statusChanges);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.patientsPaginator;
    this.dataSource.sort = this.tablePatientsSort;

    this.history.paginator = this.historyPaginator;
    this.history.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'createdBy':
          return item.createdBy.username;
        default:
          return item[property];
      }
    };
    this.history.sort = this.tableHistorySort;
  }

  openDrivers(): void {
    this.showDrivers = true;
    this.isLoadingDrivers = true;
    const driversPromise = new Promise((resolve, reject) => {
      this.usersSrv
        .getList(
          RoleName.driver,
          true,
          this.order.client.id,
          this.order.site.id,
        )
        .subscribe((usersFromSrv) => {
          if (this.order.driver) {
            this.drivers = usersFromSrv.filter((oneDriver) => {
              return oneDriver.id !== this.order.driver.id;
            });
          } else {
            this.drivers = usersFromSrv;
          }
          resolve(true);
        });
    });

    driversPromise.then(() => {
      this.isLoadingDrivers = false;
    });
  }

  confirmDriverChange(): void {
    this.isLoading = true;
    this.ordersSrv
      .assignDriver(
        this.order.id,
        this.driverForm.value.driver,
        this.driverForm.value.comment,
      )
      .subscribe(() => {
        this.isLoading = false;
        this.uiSrv.showSnackbar('orders.edit.reassigned', true);
        this.order.driver = this.driverForm.value.driver;
        this.order.status = 4;
        this.showDrivers = false;
      });
  }

  public unassignDriver(): void {
    this.isLoading = true;
    this.ordersSrv.unassignDriver(this.order).subscribe(() => {
      this.isLoading = false;
      this.order.driver = null;
    });
  }

  cancelDriverChange(): void {
    this.showDrivers = false;
  }

  modifyVoucherStep(receiver): void {
    receiver.editVoucher = true;
  }

  cancelVoucherStep(receiver): void {
    receiver.editVoucher = false;
  }

  validateVoucherStep(receiver): void {
    let object = {
      transportVoucher: this.formVoucher.value.newTransportVoucher,
    };
    this.orderStepsSrv
      .modifyTransportVoucher(receiver.id, object)
      .subscribe((result) => {
        receiver.transportVoucher = result.transportVoucher;
        receiver.editVoucher = false;
        this.formVoucher.reset();
      });
  }

  compareValues(key, order = 'asc') {
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }

      const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
      const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return order === 'desc' ? comparison * -1 : comparison;
    };
  }

  getBack(): void {
    if (this.order.driver) {
      this.router.navigate(['/missions/list']);
    } else {
      this.router.navigate(['/orders/list']);
    }
  }

  changeStatus(status: string, order: Order): void {
    const statusToSend = {
      status: 0,
      comment: null,
    };

    let canSend = true;

    if (status === 'receivedByDispatcher') {
      statusToSend.status = 2;
    } else if (status === 'treatedByDispatcher') {
      statusToSend.status = 4;
    } else if (status === 'finished') {
      statusToSend.status = 16;
      canSend = confirm('Etes-vous certain de terminer cette commande ?');
    } else if (status === 'cancelled') {
      statusToSend.status = 32;
      canSend = confirm("Etes-vous certain d'annuler cette commande ?");
    }

    if (canSend) {
      this.ordersSrv
        .changeStatus(order.id, statusToSend)
        .subscribe((results) => {
          order.status = results.status;
          order.statusChanges = results.statusChanges;
        });
    }
  }

  updateOrder(): void {
    this.ordersSrv.get(this.order.id).subscribe((orderFromSrv) => {
      this.order = orderFromSrv;
      this.onEditMode = true;
    });
  }

  onEditFinished(): void {
    this.onEditMode = false;
    this.initTable();
  }

  get totalSteps(): number {
    return this.order.receivers.length + 1;
  }

  downloadSignature(step) {
    this.orderStepsSrv.getSignature(step.id).subscribe();
  }

  downloadPhoto(step) {
    this.orderStepsSrv.getPhotoStep(step.id).subscribe();
  }

  checkIfCanEdit() {
    if (this.isDispatcher) {
      if (this.order.status === 16 || this.order.status === 32) {
        this.canEdit = false;
        this.canEditVoucher = false;
        if (this.order.status === 16) {
          this.invalidMessage = 'La mission est terminée.';
          this.canEditVoucher = true;
        } else if (this.order.status === 32) {
          this.invalidMessage = 'La mission a été annulée.';
        } else if (this.order.sender.arrivedOn) {
          this.invalidMessage =
            "Le chauffeur est déjà arrivé sur le lieu d'enlèvement.";
        }
      } else {
        this.canEdit = true;
        this.canEditVoucher = true;
      }
    } else if (this.isClient) {
      if (
        this.order.status === 1 ||
        this.order.status === 2 ||
        this.order.status === 4 ||
        this.order.status === 8 ||
        this.order.status === 64 ||
        this.order.status === 128
      ) {
        this.canEdit = true;
      } else {
        this.canEdit = false;
        this.invalidMessage =
          'Il est trop tard pour modifier la commande. Veuillez contacter le support FTSO.';
      }
    } else {
      this.canEdit = false;
    }
  }

  onExportLetter() {
    this.ordersSrv.exportLetter(this.order.id).subscribe(null, (error) => {
      if (error?.status === 400) {
        this.uiSrv.showSnackbar(
          "Il est impossible de générer une lettre de voiture pour des courses qui ont à la fois plusieurs lieux d'expédition et plusieurs lieux de destination.",
          false,
          5000,
        );
      }
    });
  }

  getControlSite(): UntypedFormControl {
    return this.formInfos.get('site') as UntypedFormControl;
  }

  getControlUrgency(): UntypedFormControl {
    return this.formInfos.get('urgency') as UntypedFormControl;
  }

  getControlLot(): UntypedFormControl {
    return this.formInfos.get('lot') as UntypedFormControl;
  }

  checkIfCanExport(): boolean {
    if (!this.order.sender) {
      this.disabledExportMessage = "Il n'y a pas de lieu d'enlèvement.";
      return false;
    }

    if (!this.order.sender.completedOn) {
      this.disabledExportMessage = "Le lieu d'enlèvement n'a pas été complété.";
      return false;
    }

    if (this.order.receivers.length === 0) {
      this.disabledExportMessage = "Il n'y a pas de destinataires.";
      return false;
    } else {
      let receiversCompleted = this.order.receivers.filter(
        (receiver) => receiver.completedOn,
      );
      if (receiversCompleted.length !== this.order.receivers.length) {
        this.disabledExportMessage =
          "Tous les destinataires n'ont pas été complétés.";
        return false;
      }
    }
    return true;
  }

  showEmailLetter() {
    this.showEmail = true;
  }

  cancelMailLetter() {
    this.formMail.reset();
    this.showEmail = false;
  }

  sendMailLetter() {
    this.isLoadingEmail = true;
    this.ordersSrv
      .sendPdfMail(this.order.id, this.formMail.value.email)
      .subscribe(() => {
        this.uiSrv.showSnackbar('Email envoyé avec succès.', false);
        this.cancelMailLetter();
        this.isLoadingEmail = false;
      });
  }

  modifyArrivedOn(step) {
    step.editArrivedOn = true;
  }

  cancelArrivedOn(step): void {
    step.editArrivedOn = false;
  }

  validateArrivedOn(step): void {
    // let object = {
    //   transportVoucher: this.formVoucher.value.newTransportVoucher
    // }
    // this.orderStepsSrv.modifyTransportVoucher(receiver.id, object).subscribe((result) => {
    //   receiver.transportVoucher = result.transportVoucher;
    //   receiver.editVoucher = false;
    //   this.formVoucher.reset();
    // })
  }

  modifyCompletedOn(step) {
    step.editCompletedOn = true;
  }

  cancelCompletedOn(step): void {
    step.editCompletedOn = false;
  }

  modifyInfos() {
    this.isLoadingSites = true;
    this.isLoadingUrgencies = true;
    this.isLoadingLots = true;

    const sitesPromise = new Promise((resolve, reject) => {
      this.sitesSrv.getList().subscribe((sitesFromSrv) => {
        this.sites = sitesFromSrv;
        resolve(true);
      });
    });

    const urgenciesPromise = new Promise((resolve, reject) => {
      this.dictionarySrv.getUrgencyList().subscribe((urgenciesFromSrv) => {
        this.urgencies = urgenciesFromSrv;
        resolve(true);
      });
    });

    const lotsPromise = new Promise((resolve) => {
      this.dictionarySrv
        .getLotsList(this.order.site.id)
        .subscribe((lotsFromSrv) => {
          this.lots = lotsFromSrv;

          resolve(true);
        });
    });

    Promise.all([sitesPromise, urgenciesPromise, lotsPromise]).then(() => {
      this.editInfos = true;
      this.isLoadingSites = false;
      this.isLoadingUrgencies = false;
      this.isLoadingLots = false;
      this.initFormInfos();
    });
  }

  validateNewInfos() {
    this.editInfos = false;

    let formValues = this.formInfos.value;

    let startDate = moment(this.order.startDate);
    let newDate = this.formatDate(startDate, formValues.startTime);

    this.formInfos.get('startDate').setValue(newDate);

    let modifiedFields = this.checkWhatChanged(this.formInfos.value);
    this.formInfos.get('modifiedFields').setValue(modifiedFields);

    if (formValues.recallTimer) {
      let recallTimer = dayjs(newDate, { utc: true })
        .subtract(formValues.recallTimer, 'minute')
        .format();

      if (this.reminder) {
        let reminderToEdit = this.reminder;
        reminderToEdit.dateTime = recallTimer;
        this.remindersSrv.put(reminderToEdit).subscribe(() => {
          this.initRecallTimer();
        });
      } else {
        this.remindersSrv.post(this.order.id, recallTimer).subscribe(() => {
          this.initRecallTimer();
        });
      }
    } else if (this.reminder) {
      this.remindersSrv.delete(this.reminder).subscribe();
    }

    if (this.canSeePrice) {
      this._patchOrderPriceIfChanged(formValues.price);
    }

    this.ordersSrv
      .patch(this.order.id, this.formInfos.value)
      .subscribe((result) => {
        this.formInfos.reset();
        this.isLoadingLots = false;
      });
  }

  private _patchOrderPriceIfChanged(newPrice: number) {
    if (this.order.price !== newPrice) {
      this.ordersSrv
        .patchPrice$(this.order.id, newPrice)
        .subscribe(() => (this.order.price = newPrice));
    }
  }

  cancelNewInfos() {
    this.editInfos = false;
  }

  initFormInfos() {
    const startMoment: moment.Moment = moment(new Date(this.order.startDate));
    const startTime: string = moment(startMoment).format('HH:mm');
    let recallTimer = null;

    if (this.reminder) {
      const startDate = dayjs(this.order.startDate);
      const recallDate = dayjs(this.reminder.dateTime);
      recallTimer = startDate.diff(recallDate, 'minute');
    }

    this.formInfos = this.fb.group({
      site: new UntypedFormControl(this.order.site, Validators.required),
      urgency: new UntypedFormControl(this.order.urgency, Validators.required),
      lot: new UntypedFormControl(this.order.lot),
      startTime: new UntypedFormControl(startTime, Validators.required),
      startDate: new UntypedFormControl(startMoment, Validators.required),
      transportVoucher: new UntypedFormControl(this.order.transportVoucher),
      recallTimer: [recallTimer, Validators.min(0)],
      modifiedFields: new UntypedFormControl(''),
      price: new UntypedFormControl(this.order.price),
    });

    this._updateLotValidators();

    this.formInfos.get('site').valueChanges.subscribe((site) => {
      this.lots = [];

      this.formInfos.get('lot').reset();
      if (typeof site !== 'string') {
        this.isLoadingLots = true;
        this.dictionarySrv.getLotsList(site?.id).subscribe((lotsFromSrv) => {
          this.lots = lotsFromSrv;
          this.isLoadingLots = false;
          this._updateLotValidators();
        });
      }
    });
  }

  private _updateLotValidators(): void {
    if (!this.formInfos) return;

    this.formInfos.get('lot').setValidators([Validators.required]);

    if (this.lots.length === 0) {
      this.formInfos.get('lot').removeValidators(Validators.required);
    } else if (this.lots.length === 1) {
      this.formInfos.get('lot').setValue(this.lots[0]);
    }

    this.formInfos.get('lot').updateValueAndValidity();
  }

  private formatDate(startDate: any, startTime): Date {
    const startDate2: moment.Moment = startDate.local();
    const startTime2: number[] = startTime
      .split(':')
      .map((s) => parseInt(s, 10));
    return startDate2
      .hours(startTime2[0])
      .minutes(startTime2[1])
      .utc()
      .toDate();
  }

  checkWhatChanged(orderCopy): string[] {
    let modifiedFields = [];

    if (this.order.price !== orderCopy.price) {
      modifiedFields.push('Prix');
    }

    if (this.order.site.id !== orderCopy.site.id) {
      modifiedFields.push("Donneur d'ordre");
    }

    if (this.order.transportVoucher != orderCopy.transportVoucher) {
      modifiedFields.push('Numéro de bon de transport');
    }

    if (this.order.urgency.id !== orderCopy.urgency.id) {
      modifiedFields.push("Niveau d'urgence");
    }

    if (
      new Date(this.order.startDate).toString() !==
      new Date(orderCopy.startDate).toString()
    ) {
      modifiedFields.push('Dates/heures de prise en charge souhaitée');
    }

    for (let i = 1; i < modifiedFields.length; i++) {
      modifiedFields[i] = modifiedFields[i];
    }

    return modifiedFields;
  }

  modifyStep(step) {
    this.stepOnEditMode = true;
    step.editMode = true;
    this.isLoadingAddresses = true;

    const senderPromise = new Promise((resolve, reject) => {
      this.adressesSrv.getSenderList().subscribe((sendersFromSrv) => {
        this.senders = sendersFromSrv;
        resolve(true);
      });
    });

    const receiversPromise = new Promise((resolve, reject) => {
      this.adressesSrv.getReceiverList().subscribe((receiversFromSrv) => {
        this.receivers = receiversFromSrv;
        resolve(true);
      });
    });

    Promise.all([senderPromise, receiversPromise]).then(() => {
      this.isLoadingAddresses = false;
      this.initFormStep(step);
    });
  }

  validateNewStep(step) {
    step.editMode = false;
    this.stepOnEditMode = false;
    let formValues = this.formStep.value;

    if (step.completedOn && formValues.completedTime) {
      let completedOn = moment(formValues.completedOn);
      let newDateCompleted = this.formatDate(
        completedOn,
        formValues.completedTime,
      );
      this.formStep.get('completedOn').setValue(newDateCompleted);
    }

    if (step.arrivedOn && formValues.arrivedTime) {
      let arrivedOn = moment(formValues.arrivedOn);
      let newDateArrived = this.formatDate(arrivedOn, formValues.arrivedTime);
      this.formStep.get('arrivedOn').setValue(newDateArrived);
    }

    if (typeof formValues.address === 'string') {
      this.formStep.get('otherAddress').setValue(formValues.address);
      this.formStep.get('address').setValue(null);
    } else {
      this.formStep.get('otherAddress').setValue(null);
    }

    if (formValues.waitingTime) {
      let hours = parseInt(formValues.waitingTime.split(':')[0]);
      let minutes = parseInt(formValues.waitingTime.split(':')[1]);

      let total = hours * 60 + minutes;

      this.formStep.get('waitingTime').setValue(total);
    }

    this.orderStepsSrv
      .patchStep(step.id, this.formStep.value)
      .subscribe((result) => {
        step.completedOn = result.completedOn;
        step.arrivedOn = result.arrivedOn;
        step.transportVoucher = result.transportVoucher;
        step.address = result.address;
        step.otherAddress = result.otherAddress;
        step.waitingTime = result.waitingTime;
        this.formStep.reset();
      });
  }

  cancelNewStep(step) {
    step.editMode = false;
    this.stepOnEditMode = false;
  }
  // TODO ajouter dans les modifiedFields les champs de ce form aussi
  initFormStep(step) {
    let completedOn;
    let completedTime;
    let arrivedOn;
    let arrivedTime;
    let waitingTime;

    if (step.completedOn) {
      const startMoment: moment.Moment = moment(new Date(step.completedOn));
      const startTime: string = moment(startMoment).format('HH:mm');

      completedOn = startMoment;
      completedTime = startTime;
    }

    if (step.arrivedOn) {
      const arrivedMoment: moment.Moment = moment(new Date(step.arrivedOn));
      const arrivedTime2: string = moment(arrivedMoment).format('HH:mm');

      arrivedOn = arrivedMoment;
      arrivedTime = arrivedTime2;
    }

    let address;

    if (step.otherAddress) {
      address = step.otherAddress;
    } else {
      address = Address.fromObject(step.address);
    }

    if (step.waitingTime) {
      waitingTime = this.convertMinsToHours(step.waitingTime);
    }

    this.formStep = this.fb.group({
      address: new UntypedFormControl(address, Validators.required),
      otherAddress: new UntypedFormControl(step.otherAddress),
      completedTime: new UntypedFormControl(completedTime),
      completedOn: new UntypedFormControl(completedOn),
      arrivedTime: new UntypedFormControl(arrivedTime),
      arrivedOn: new UntypedFormControl(arrivedOn),
      transportVoucher: new UntypedFormControl(step.transportVoucher),
      waitingTime: new UntypedFormControl(waitingTime),
    });

    const fieldsRequiredIfCompleted = [
      { field: 'completedOn', condition: completedOn },
      { field: 'completedTime', condition: completedTime },
      { field: 'arrivedOn', condition: arrivedOn },
      { field: 'arrivedTime', condition: arrivedTime },
    ];

    fieldsRequiredIfCompleted.forEach(({ field, condition }) => {
      if (condition) {
        this.formStep.get(field).setValidators(Validators.required);
      }
    });
  }

  getControlAddressStep(): UntypedFormControl {
    return this.formStep.get('address') as UntypedFormControl;
  }

  public downloadAsPDF() {
    this.isLoadingRoadLetter = true;

    this.ordersSrv.exportRoadmap(this.order.id).subscribe(() => {
      this.isLoadingRoadLetter = false;
    });

    // Generate PDF
    // if (this.canHaveTemperatures()) {
    //   this.ordersSrv.getTemperatures(this.order.id).subscribe({
    //     next: (data) => {
    //       this.temperatures = data;
    //
    //       if (this.temperatures?.length > 0) {
    //         this.temperatures.map(temp => {
    //           this.combineTemperaturesWithSteps(temp);
    //         })
    //       }
    //
    //       this.generatePDF();
    //     },
    //     error: (error) => {
    //       this.uiSrv.showSnackbar(error.error);
    //       console.error('error: ', error);
    //     }
    //   })
    // } else {
    //   this.generatePDF();
    // }
  }

  generatePDF() {
    let options: jsPDFOptions = {
      orientation: 'p',
      unit: 'px',
      hotfixes: ['px_scaling'],
      format: 'a4',
    };

    let site = "Donneur d'ordre : " + this.order.site.name;

    const doc = new jsPDF(options);
    // doc.text('Feuille de route | ' + site, 20, 20);
    const pdfTable = this.pdfTable.nativeElement;

    let identifier = this.order.identifier;

    const pageFormat = 'a4';
    const pageOrient = 'p';

    const pageMarginX = 20;
    const pageMarginY = 20;
    const pageWidth = doc.internal.pageSize.width - pageMarginX * 2;

    new jsPDF(options).html(pdfTable.innerHTML, {
      x: 0,
      y: 0,
      margin: [pageMarginY, pageMarginX, pageMarginY, pageMarginX],
      width: pageWidth,
      windowWidth: pageWidth,
      autoPaging: 'text',
      callback: (res) => {
        if (res.getNumberOfPages() > 1) {
          for (
            let i = res.getNumberOfPages(), j = res.getNumberOfPages();
            i <= j;
            i++
          ) {
            doc.addPage(pageFormat, pageOrient);
          }
        }

        // render document proper
        doc.html(pdfTable.innerHTML, {
          x: 0,
          y: 0,
          margin: [pageMarginY, pageMarginX, pageMarginY, pageMarginX],
          width: pageWidth,
          windowWidth: pageWidth,
          autoPaging: 'text',
          callback: function () {
            var pageCount = doc.getNumberOfPages(); //Total Page Number
            for (let i = 0; i < pageCount; i++) {
              doc.setPage(i);
              let pageCurrent = doc.getCurrentPageInfo().pageNumber; //Current Page
              doc.setFontSize(8);
              doc.text(
                'Page: ' + pageCurrent + '/' + pageCount,
                15,
                doc.internal.pageSize.height - 5,
              );
            }
            doc.save(`feuille_de_route_${identifier}.pdf`);
          },
        });
        this.isLoadingRoadLetter = false;
      },
    });
  }

  canHaveTemperatures(): boolean {
    const senderCompleted = this.order.sender.completedOn ? true : false;
    const oneStepCompleted = this.order.receivers.find(
      (receiver) => receiver.completedOn,
    )
      ? true
      : false;
    const atLeastOneTag = this.order.sender.scans.find(
      (scan) => scan.container.tag,
    )
      ? true
      : false;

    return senderCompleted && oneStepCompleted && atLeastOneTag;
  }

  notifyDriver() {
    const dialog = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: '500px',
      data: {
        title: 'orders.detail.dialogNotifyDriver.title',
        content: 'orders.detail.dialogNotifyDriver.content',
      },
    });
    dialog.afterClosed().subscribe((response) => {
      if (response)
        this.remindersSrv.sendReminder(this.order.id).subscribe(() => {
          this.uiSrv.showSnackbar('Notification envoyée au chauffeur', false);
        });
    });
  }

  convertMinsToHours(mins) {
    let h: number | string = Math.floor(mins / 60);
    let m: number | string = mins % 60;
    h = h < 10 ? '0' + h : h; // (or alternatively) h = String(h).padStart(2, '0')
    m = m < 10 ? '0' + m : m; // (or alternatively) m = String(m).padStart(2, '0')
    return `${h}:${m}`;
  }

  editInternalComment() {
    this.editInternalCommentFlag = true;

    this.formInternalComment = this.fb.group({
      internalComment: new UntypedFormControl(this.internalComment ?? '', [
        Validators.maxLength(500),
      ]),
    });
  }

  validateEditionInternalComment() {
    this.ordersSrv
      .patchInternalComment(this.order.id, this.formInternalComment.value)
      .subscribe(() => {
        this.internalComment = this.formInternalComment.value.internalComment;

        this.closeEditionInternalComment();
      });
  }

  closeEditionInternalComment() {
    this.formInternalComment.reset();

    this.editInternalCommentFlag = false;
  }

  combineTemperaturesWithSteps(orderStepTemp: OrderStepTemperature) {
    let sender = this.order.sender;
    let steps = this.order.receivers;

    if (orderStepTemp.stepId === sender.id) {
      orderStepTemp.temperatures.map((temp) => {
        let scan = sender.scans.find(
          (scan) => !scan.code && scan.container.tag === temp.tag,
        );
        if (scan) scan.temperature = temp;
      });
    }

    let receiver = steps.find((s) => s.id === orderStepTemp.stepId);

    if (receiver) {
      orderStepTemp.temperatures.map((temp) => {
        let scan = sender.scans.find(
          (scan) => !scan.code && scan.container.tag === temp.tag,
        );
        if (scan) scan.temperature = temp;
      });
    }
  }

  concatAllScans() {
    this.allScans = this.allScans.concat(this.order.sender?.scans);

    this.order.receivers.map((receiver) => {
      this.allScans = this.allScans.concat(receiver?.scans);
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public onUploadFile(event: any): void {
    if (event.target.files.length > 0) {
      const file: File = event.target.files[0];
      this._addDocument(file);
    }
  }

  private async _addDocument(file: File) {
    const fileInfo = await this._postFile(file);
    const fileName = this._fileNameWithoutExtension(file.name);
    const addDocumentRequest = new AddOrderDocumentRequest(fileInfo, fileName);
    this._postDocument(addDocumentRequest);
  }

  private _fileNameWithoutExtension(fileName: string): string {
    return fileName.substring(0, fileName.lastIndexOf('.'));
  }

  private _postFile(file: File): Promise<FileInfo> {
    return new Promise((resolve) => {
      this._fileSrv.postFile(file).subscribe((fileInfo: FileInfo) => {
        resolve(fileInfo);
      });
    });
  }

  private _postDocument(addDocumentRequest: AddOrderDocumentRequest): void {
    this.ordersSrv
      .postDocument$(this.order.id, addDocumentRequest)
      .subscribe(() => {
        this.uiSrv.showSnackbar('Document ajouté avec succès', false);
      });
  }

  public onDocumentClick(): void {
    this._openDocumentsDialog();
  }

  private _openDocumentsDialog(): MatDialogRef<
    OrderDocumentsDialogComponent,
    any
  > {
    return this.dialog.open(OrderDocumentsDialogComponent, {
      maxWidth: '500px',
      data: {
        orderId: this.order.id,
      },
    });
  }

  public openInMworker(): void {
    this._mWorkerService.openOrderInMworker(this.order);
  }

  public displayMworkerButton(): boolean {
    return this._mWorkerService.canGenerateLink(this.order);
  }
}
